import { attr, belongsTo } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validateInclusion,
  validatePresence
} from "ember-changeset-validations/validators";
import type IntlService from "ember-intl/services/intl";
import type ConnectedDeviceAcquiredJournalEvent from "parog-web/models/connected-device-acquired-journal-event";
import type DeviceOrderRefusedJournalEvent from "parog-web/models/device-order-refused-journal-event";
import JournalEvent from "parog-web/models/journal-event";
import tWithDefault from "parog-web/utils/t-with-default";

//---- Automatically generated, don't update this part ----

type DeviceTypeStringEnum = "blood-pressure-monitor" | "scales";

/**
 * Fired when a PS asked for a Withings tensiometer
 */
export default class DeviceOrderedJournalEvent extends JournalEvent {
  static override type = "device-ordered-journal-event";

  @attr("string") declare deviceType: DeviceTypeStringEnum;

  @belongsTo("connected-device-acquired-journal-event", {
    async: false,
    inverse: "deviceOrderedJournalEvent"
  })
  declare connectedDeviceAcquiredJournalEvent: ConnectedDeviceAcquiredJournalEvent;

  @belongsTo("device-order-refused-journal-event", {
    async: false,
    inverse: "deviceOrderedJournalEvent"
  })
  declare deviceOrderRefusedJournalEvent: DeviceOrderRefusedJournalEvent;

  static override validations(intl: IntlService) {
    return {
      deviceType: [
        validatePresence({
          presence: true,
          description: intl.t(
            "validations.device-ordered-journal-event.device-type"
          )
        }),
        validateInclusion({
          list: ["blood-pressure-monitor", "scales"],
          description: intl.t(
            "validations.device-ordered-journal-event.device-type"
          )
        })
      ],
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.device-ordered-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ]
    };
  }

  //---- End of generated code ----

  get hasBeenRefused() {
    return !!this.deviceOrderRefusedJournalEvent;
  }

  get hasBeenAccepted() {
    return !!this.connectedDeviceAcquiredJournalEvent;
  }

  get isPending() {
    return (
      !this.deviceOrderRefusedJournalEvent &&
      !this.connectedDeviceAcquiredJournalEvent
    );
  }

  get hasBeenDelivered() {
    return (
      this.connectedDeviceAcquiredJournalEvent.deliveryStatus == "delivered"
    );
  }
}

export type { DeviceTypeStringEnum };

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "device-ordered-journal-event": DeviceOrderedJournalEvent;
  }
}
